if (!customElements.get('customer-media-reviews')) {
  customElements.define(
    'customer-media-reviews',
    class CustomerMediaReviews extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.selectors = {
          items: '.cmr__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        };
        this.classes = {
          grid: 'f-grid',
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        initCustomVideoPlayerWithHLS(this.sectionId);
        readMoreModal(this.sectionId);
        this.section = this.closest(`.section-${this.sectionId}`) || this.closest('.section');
        this.itemsEl = this.querySelector(this.selectors.items);

        this.mobileItems = this.dataset.mobileItems || '1.2';
        this.tabletItems = this.dataset.tabletItems || '2.2';
        this.desktopItems = this.dataset.desktopItems || '2.2';

        this.sliderInstance = false;

        if (!this.itemsEl) return;

        this.init();
        window.addEventListener('resize', FoxTheme.utils.debounce(() => {
          this.reinit();
        }, 100));
      }

      init() {
        if (typeof this.sliderInstance === 'object') return;

        const columnGap = FoxTheme.utils.getGridColumnGap(this.itemsEl);
        console.log(this.desktopItems);
        const sliderOptions = {
          slidesPerView: this.mobileItems,
          spaceBetween: columnGap.mobile || columnGap.tablet || 16,
          navigation: {
            nextEl: this.section?.querySelector(this.selectors.nextEl),
            prevEl: this.section?.querySelector(this.selectors.prevEl),
          },
          pagination: false,
          breakpoints: {
            768: {
              slidesPerView: this.tabletItems,
              spaceBetween: columnGap.tablet,
            },
            1024: {
              slidesPerView: this.desktopItems,
              spaceBetween: columnGap.tabletLarge,
            },
            1280: {
              slidesPerView: this.desktopItems,
              spaceBetween: columnGap.desktop,
            },
          },
          loop: false,
          threshold: 2,
        };

        this.classList.add(this.classes.swiper);
        this.itemsEl.classList.remove(this.classes.grid);
        this.itemsEl.classList.add(this.classes.swiperWrapper);

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }

      reinit() {
        if (typeof this.sliderInstance === 'object') {
          this.sliderInstance.slider.destroy(true, true);
          this.sliderInstance = false;
          this.itemsEl.classList.remove(this.classes.swiperWrapper);
          this.itemsEl.classList.add(this.classes.grid);
        }
        this.init();
      }
    }
  );
}
